export const BOX_COLORS = Object.freeze({
  HAVANA: 'havana',
  WHITE: 'white'
})

export const BOX_TYPES = Object.freeze({
  ONE_WAVE: 'one_wave',
  TWO_WAVES: 'two_waves',
  THREE_WAVES: 'three_wave'
})

export const BOX_PRINTINGS = Object.freeze({
  NONE: null,
  ONE_COLOR: 'one_color',
  TWO_COLORS: 'two_colors',
  THREE_COLORS: 'three_colors',
  TRICHROME: 'trichrome',
  LITOGRAPHY: 'lithography'
})

export const PUNCHED_BOX_TYPES = Object.freeze({
  MICRO_WAVE: 'micro_wave',
  LOW_WAVE: 'low_wave',
  HIGH_WAVE: 'high_wave',
  MICRO_TRIPLE: 'micro_triple'
})

export const COAT_HANGER_BOX_OPENINGS = Object.freeze({
  TOP: 'top',
  DIAGONAL: 'diagonal',
  HORIZONTAL: 'horizontal',
  FRONTAL: 'frontal'
})

export const BOTTLE_BOX_TYPES = Object.freeze({
  BRIEF_CASE: 'brief_case',
  SLIP_CASE: 'slip_case'
})

export const BOX_SIZE_TYPES = Object.freeze({
  INTERNAL: 'internal',
  EXTERNAL: 'external'
})
